<template>
  <div class="main-panel">
    <div class="content-wrapper sucursal-shell">
      <div class="cardplay sucursal-card">
        <div class="row sucursal-header g-3 align-items-center">
          <div class="col-12 col-lg-8">
            <h2 class="sucursal-title mb-1">{{ form.id > 0 ? "Editar Sucursal" : "Nueva Sucursal" }}</h2>
            <p class="sucursal-subtitle mb-0">Define nombre, descripcion, ubicacion y encargado.</p>
          </div>
          <div class="col-12 col-lg-4 d-flex justify-content-lg-end">
            <router-link class="btn btn-light sucursal-secondary-btn" to="/sucursales">
              Volver
            </router-link>
          </div>
        </div>

        <form class="form-card" @submit.prevent="saveSucursal">
          <div v-if="loading" class="loading-shell">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            Cargando sucursal...
          </div>

          <div v-else class="row g-3">
            <div class="col-12 col-lg-6">
              <label class="form-label" for="nombre">Nombre</label>
              <input id="nombre" v-model.trim="form.nombre" class="form-control" type="text" required />
            </div>

            <div class="col-12 col-lg-6">
              <label class="form-label" for="ubicacion">Ubicacion</label>
              <input id="ubicacion" v-model.trim="form.ubicacion" class="form-control" type="text" />
            </div>

            <div class="col-12 col-lg-6">
              <label class="form-label" for="encargadoId">Encargado ID</label>
              <input id="encargadoId" v-model.number="form.encargadoId" class="form-control" type="number" min="0" />
            </div>

            <div class="col-12">
              <label class="form-label" for="descripcion">Descripcion</label>
              <textarea id="descripcion" v-model.trim="form.descripcion" class="form-control" rows="4"></textarea>
            </div>

            <div class="form-actions">
              <router-link class="btn btn-light sucursal-secondary-btn" to="/sucursales">Cancelar</router-link>
              <button class="btn btn-primary sucursal-save-btn" type="submit" :disabled="saving">
                <span v-if="saving" class="spinner-border spinner-border-sm" role="status"></span>
                Guardar Sucursal
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Security from "../security";

export default {
  data() {
    return {
      loading: false,
      saving: false,
      form: {
        id: 0,
        nombre: "",
        descripcion: "",
        ubicacion: "",
        encargadoId: 0,
        createUserId: 0,
        activo: true,
      },
    };
  },
  beforeMount() {
    Security.requireToken();
    this.loadSucursal();
  },
  methods: {
    emptyForm() {
      return {
        id: 0,
        nombre: "",
        descripcion: "",
        ubicacion: "",
        encargadoId: 0,
        createUserId: 0,
        activo: true,
      };
    },
    loadSucursal() {
      const id = parseInt(String(this.$route.params.sucursalId || 0), 10);
      if (!id) {
        this.form = this.emptyForm();
        this.form.createUserId = Security.getUser()?.[0]?.user?.id || 0;
        return;
      }

      this.loading = true;
      fetch(process.env.VUE_APP_API_URL + "/admin/sucursales/" + id, Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.showError(response.message);
            return;
          }

          this.form = response.data?.sucursal || this.emptyForm();
        })
        .catch((error) => this.showError(error))
        .finally(() => {
          this.loading = false;
        });
    },
    saveSucursal() {
      const payload = {
        id: this.form.id,
        nombre: this.form.nombre.trim(),
        descripcion: this.form.descripcion.trim(),
        ubicacion: this.form.ubicacion.trim(),
        encargadoId: Number(this.form.encargadoId || 0),
        createUserId: Number(this.form.createUserId || Security.getUser()?.[0]?.user?.id || 0),
        activo: true,
      };

      if (!payload.nombre) {
        this.showError("El nombre de la sucursal es requerido.");
        return;
      }

      this.saving = true;
      fetch(process.env.VUE_APP_API_URL + "/admin/sucursales/save", Security.requestOptions(payload))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.showError(response.message);
            return;
          }

          Swal.fire({
            icon: "success",
            title: "Sucursal guardada",
            showConfirmButton: false,
            timer: 1200,
          });
          this.$router.push("/sucursales");
        })
        .catch((error) => this.showError(error))
        .finally(() => {
          this.saving = false;
        });
    },
    showError(message) {
      Swal.fire({
        icon: "error",
        title: "No se pudo completar",
        text: String(message),
      });
    },
  },
};
</script>

<style scoped>
.sucursal-shell {
  background: linear-gradient(165deg, #f6f7fa 0%, #edf0f5 48%, #fafafa 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 22px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 22px 54px rgba(15, 23, 42, 0.07);
}

.sucursal-header {
  background: linear-gradient(120deg, #20242b 0%, #343a43 72%, #4b5563 100%);
  border-radius: 16px;
  color: #fff;
  padding: 14px 16px;
  margin-bottom: 18px;
}

.sucursal-title {
  color: #fff;
  font-weight: 700;
  margin: 0;
}

.sucursal-subtitle {
  color: #e5e7eb;
  font-size: 0.93rem;
}

.form-card {
  background: #ffffff;
  border: 1px solid #e3e7ee;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
  padding: 14px;
}

.form-label {
  color: #374151;
  font-size: 0.88rem;
  font-weight: 700;
}

.form-control {
  border-color: #dce1e8;
  border-radius: 9px;
  min-height: 38px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.sucursal-save-btn,
.sucursal-secondary-btn {
  border-radius: 10px;
  min-height: 38px;
  padding-inline: 14px;
  font-weight: 600;
}

.loading-shell {
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  min-height: 120px;
}
</style>
